import { RepairOrderFilter } from 'features/workshop-planner/api/repositories/use-repair-order.query';
import { createContext, useContext } from 'react';

export type PreviewFileType = {
  fileUrl: string;
  isVideo?: boolean;
};
export type PreviewImageContextProps = {
  previewImages?: PreviewFileType[];
  openIndex?: number;
  showPreviewImage: (images?: PreviewFileType[], openIndexFile?: number) => void;
};

export const PreviewImageContext = createContext<PreviewImageContextProps>({
  showPreviewImage: function (images?: PreviewFileType[]): void {
    throw new Error('Function not implemented.');
  }
});

export const usePreviewImageContext = () => useContext(PreviewImageContext);
